import { render, staticRenderFns } from "./Main-Footer.vue?vue&type=template&id=3e487bfa&scoped=true&"
var script = {}
import style0 from "./Main-Footer.vue?vue&type=style&index=0&id=3e487bfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e487bfa",
  null
  
)

export default component.exports